import { PeriodPresetType } from '@services/MarppleShopStudio/features/repositories/statistics';
import { differenceInDays } from 'date-fns';
import { z } from 'zod';

export const dateRangeValidator = {
  validate: <T extends object, K extends keyof T>(
    data: T,
    start_date_key: K,
    end_date_key: K,
    max_days?: number,
  ) => {
    return (
      z.object({
        [start_date_key]: z.coerce.date(),
        [end_date_key]: z.coerce.date(),
      }) as z.ZodType<{ [key in K]: Date }>
    )
      .refine((data) => data[end_date_key] >= data[start_date_key], {
        message: '종료 날짜는 시작 날짜보다 이전일 수 없습니다.',
      })
      .refine((data) => !max_days || differenceInDays(data[end_date_key], data[start_date_key]) <= max_days, {
        message: `날짜 간격은 ${max_days}일 이내여야 합니다.`,
      })
      .parse(data);
  },
};

// 리뷰 필요..
export const periodValidator = {
  validate: <T extends Record<string, unknown>, K extends keyof T>(data: T, period_key: K) => {
    return (
      z.object({
        [period_key]: z.coerce.string(),
      }) as z.ZodType<{ [key in K]: PeriodPresetType }>
    ).parse(data);
  },
};
